module.exports = __webpack_public_path__ + "img/jiekou.be391ea2.png";